export default "__VITE_ASSET__DGIz3H42__"